import { LEGAL_LABELS } from './legal_labels';
import { LEGAL_URLS } from './legal_urls';
const SUPPORTED_LANGUAGES = ['de', 'fr', 'it', 'en'];
/**
 * Normalizes an arbitrary language code to a supported {@link LegalLanguage},
 * falling back to German for anything unrecognized.
 *
 * @param language - A language code (e.g. "de", "fr-CH", "en-US").
 * @returns The matching supported legal language, or "de".
 */
function to_legal_language(language) {
    const code = language.slice(0, 2).toLowerCase();
    return SUPPORTED_LANGUAGES.includes(code) ? code : 'de';
}
/**
 * Resolves the ordered list of legal links (Impressum, then Datenschutz) for a
 * given language, combining the shared URLs and labels into ready-to-render
 * objects.
 *
 * @param language - A language code; unsupported values fall back to German.
 * @returns The resolved legal links in display order.
 */
export function get_legal_links(language) {
    const lang = to_legal_language(language);
    const labels = LEGAL_LABELS[lang];
    return [
        { kind: 'impressum', label: labels.impressum, url: LEGAL_URLS.impressum[lang] },
        { kind: 'datenschutz', label: labels.datenschutz, url: LEGAL_URLS.datenschutz[lang] },
    ];
}
//# sourceMappingURL=get_legal_links.js.map